import { RESPONSEDATA } from "app/shared/services/services-model.type";
import { DataTransferCreate } from "../../reducer/types";
import {
  FETCH_TRANSFER_STOCK_BRANCH_REQUEST,
  FETCH_TRANSFER_STOCK_BRANCH_SUCCESS,
  FETCH_TRANSFER_STOCK_BRANCH_FAILURE,
  FETCH_TRANSFER_STOCK_CREATE_REQUEST,
  FETCH_TRANSFER_STOCK_CREATE_SUCCESS,
  FETCH_TRANSFER_STOCK_CREATE_FAILURE,
  FETCH_TRANSFER_STOCK_CONFIRM_REQUEST,
  FETCH_TRANSFER_STOCK_CONFIRM_SUCCESS,
  FETCH_TRANSFER_STOCK_CONFIRM_FAILURE,
  FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_FAILURE,
  SET_TRANSFER_STOCK_STORE,
  SET_TRANSFER_STOCK_RESET,
  FETCH_TRANSFER_STOCK_MAKE_FEE_REQUEST,
  FETCH_TRANSFER_STOCK_MAKE_FEE_SUCCESS,
  FETCH_TRANSFER_STOCK_MAKE_FEE_FAILURE,
} from "./actions.type";
import {
  FetchTransferStockCreateRequest,
  FetchTransferStockCreateSuccess,
  FetchTransferStockCreateFailure,
  FetchTransferStockConfirmRequest,
  FetchTransferStockConfirmSuccess,
  FetchTransferStockConfirmFailure,
  FetchTransferStockAuthorizationRequest,
  FetchTransferStockAuthorizationSuccess,
  FetchTransferStockAuthorizationFailure,
  SetTransferStockStore,
  TransferStockState,
  SetTransferStockReset,
  FetchTransferStockMakeFeeFailure,
  FetchTransferStockMakeFeeSuccess,
  FetchTransferStockMakeFeeRequest,
  FetchTransferStockBranchRequest,
  FetchTransferStockBranchSuccess,
  FetchTransferStockBranchFailure,
} from "./types";

export const fetchTransferStockBranchRequest = (payload?: string): FetchTransferStockBranchRequest => ({
  type: FETCH_TRANSFER_STOCK_BRANCH_REQUEST,
  payload,
});

export const fetchTransferStockBranchSuccess = (payload?: RESPONSEDATA): FetchTransferStockBranchSuccess => ({
  type: FETCH_TRANSFER_STOCK_BRANCH_SUCCESS,
  payload,
});

export const fetchTransferStockBranchFailure = (payload?: string): FetchTransferStockBranchFailure => ({
  type: FETCH_TRANSFER_STOCK_BRANCH_FAILURE,
  payload,
});

// Stock
export const fetchTransferStockCreateRequest = (payload?: DataTransferCreate): FetchTransferStockCreateRequest => ({
  type: FETCH_TRANSFER_STOCK_CREATE_REQUEST,
  payload,
});

export const fetchTransferStockCreateSuccess = (payload?: RESPONSEDATA): FetchTransferStockCreateSuccess => ({
  type: FETCH_TRANSFER_STOCK_CREATE_SUCCESS,
  payload,
});

export const fetchTransferStockCreateFailure = (payload?: string): FetchTransferStockCreateFailure => ({
  type: FETCH_TRANSFER_STOCK_CREATE_FAILURE,
  payload,
});

export const fetchTransferStockConfirmRequest = (payload?: RESPONSEDATA): FetchTransferStockConfirmRequest => ({
  type: FETCH_TRANSFER_STOCK_CONFIRM_REQUEST,
  payload,
});

export const fetchTransferStockConfirmSuccess = (payload?: RESPONSEDATA): FetchTransferStockConfirmSuccess => ({
  type: FETCH_TRANSFER_STOCK_CONFIRM_SUCCESS,
  payload,
});

export const fetchTransferStockConfirmFailure = (payload?: string): FetchTransferStockConfirmFailure => ({
  type: FETCH_TRANSFER_STOCK_CONFIRM_FAILURE,
  payload,
});

export const fetchTransferStockAuthorizationRequest = (payload?: RESPONSEDATA, code?: string): FetchTransferStockAuthorizationRequest => ({
  type: FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTransferStockAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTransferStockAuthorizationSuccess => ({
  type: FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTransferStockAuthorizationFailure = (errorOTP: boolean, payload?: string): FetchTransferStockAuthorizationFailure => ({
  type: FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

// Tính phí
export const fetchTransferStockMakeFeeRequest = (payload?: DataTransferCreate): FetchTransferStockMakeFeeRequest => ({
  type: FETCH_TRANSFER_STOCK_MAKE_FEE_REQUEST,
  payload,
});

export const fetchTransferStockMakeFeeFailure = (payload?: string): FetchTransferStockMakeFeeFailure => ({
  type: FETCH_TRANSFER_STOCK_MAKE_FEE_FAILURE,
  payload,
});

export const fetchTransferStockMakeFeeSuccess = (payload?: RESPONSEDATA): FetchTransferStockMakeFeeSuccess => ({
  type: FETCH_TRANSFER_STOCK_MAKE_FEE_SUCCESS,
  payload,
});

export const setTransferStockStore = (payload?: TransferStockState): SetTransferStockStore => ({
  type: SET_TRANSFER_STOCK_STORE,
  payload,
});

export const setTransferStockReset = (): SetTransferStockReset => ({
  type: SET_TRANSFER_STOCK_RESET,
});
